import { Address, emptyAddress } from 'common/api/models/Address';

export interface FamilyAddress extends Address {
    id: string;
    phoneNumber: string;
    firstName: string;
    lastName: string;
}

export const emptyFamilyAddress: FamilyAddress = {
    ...emptyAddress,
    id: '',
    phoneNumber: '',
    firstName: '',
    lastName: '',
};
